module.exports = require('./helpers/bundle-url').getBundleURL('kuLgW') + "firebase-messaging-service-worker.js";